import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./report.scss";
import SearchIcon from "../icons/SearchIcon";
import DocIcon from "../icons/DocIcon";
import { useTranslation } from "react-i18next";

const reports = [
  { name: "Brief Summary" },
  { name: "Invoice Summary" },
  { name: "Customer Summary" },
  { name: "Sales by Location" },
  { name: "Sales by SKU" },
  { name: "Sales by Metal" },
  { name: "Sales by Metal & Stone" },
  { name: "Sales by Stone" },
  { name: "Sales by Size" },
  { name: "Sales by Collection" },
  { name: "Sales by Style" },
  { name: "Sales by Salesperson" },
  { name: "Sales by Item" },
  { name: "Sales by Stock Aging" },
  { name: "Item Price Range" },
];

export default function ReportList() {
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const filtered = reports.filter((r) =>
    r.name.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div className="main-container">
      {/* Top Bar */}
      <div className="top-bar">
        <span className="title">{t("Report")}</span>
        <div className="search">
          <SearchIcon />
          <input
            placeholder={`${t("Search Report ...")}`}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            // style={{
            //   border: "none", outline: "none", fontSize: 13,
            //   color: "#333", width: "100%", background: "transparent"
            // }}
          />
        </div>
      </div>

      {/* Report List */}
      <div>
        {filtered.map((report, i) => (
          <div key={i} className="report-item">
            <DocIcon />
            <span
              onClick={() =>
                navigate(
                  `/app/admin/reports/${report.name.toLowerCase().replace(/\s+/g, "-")}`,
                )
              }
            >
              {t(report.name)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
